<div class="manage-user-container">
    <h4 style="padding: 0 10px;">Users List</h4>
    @if (updatingUserInfo() || fetchingUserInfo() || isFetchingUserList()) {
    <rs-loader></rs-loader>
    }
    @if (fetchingUserErrors()) {
    <p class="error">{{fetchingUserErrors()}}</p>
    }
    @if (!isFetchingUserList() && !fetchingUserErrors() && !users().length) {
    <p class="error">No users were created by you</p>
    }
    @if (users().length) {
        <table>
            <thead>
                <th><button type="button" class="sort-button" (click)="sortTheUserList('userName')">User Name
                    @if (sortField() === 'userName' && sortOrder() === 'DESC') {
                    <span>&#8595;</span>
                    }
                    @if (sortField() === 'userName' && sortOrder() === 'ASC') {
                    <span>&#8593;</span>
                    }
                </button></th>
                <th><button type="button" class="sort-button" (click)="sortTheUserList('userType')">User Type
                    @if (sortField() === 'userType' && sortOrder() === 'DESC') {
                    <span>&#8595;</span>
                    }
                    @if (sortField() === 'userType' && sortOrder() === 'ASC') {
                    <span>&#8593;</span>
                    }
                </button></th>
                <th></th>
                <th></th>
                <th><button type="button" class="sort-button" (click)="sortTheUserList('userStatus')">User Status
                    @if (sortField() === 'userStatus' && sortOrder() === 'DESC') {
                    <span>&#8595;</span>
                    }
                    @if (sortField() === 'userStatus' && sortOrder() === 'ASC') {
                    <span>&#8593;</span>
                    }
                </button></th>
            </thead>
            <tbody>
                @for (user of users(); track user.userName) {
                <tr>
                    <td>{{user.userName}}</td>
                    <td>{{user.userType}}</td>
                    <td><a (click)="navigateByAction('manage', user)">Manage User</a></td>
                    <td><a (click)="navigateByAction('authorizations', user)">Authorizations</a></td>
                  <td>{{user.userStatus}}
                    <button class="enable-disable-user" (click)="enableDisableUser(user.userName, user.userStatus === 'Enabled')" rs-raised-button
                            [color]="user.userStatus === 'Enabled' ? 'secondary' : 'primary'">{{user.userStatus === 'Enabled' ? 'Disable' : 'Enable'}}</button>
                  </td>
                </tr>
                }
            </tbody>
        </table>
        <rs-paginator [showFirstLastButtons]="1" [length]="totalUsers()"
                        (page)="getMoreUsers($event)"
                        [pageSize]="defaultPageSize"></rs-paginator>
    }
</div>
<!-- Confirmation popup -->
<rs-dialog [visible]="!!manageUserInfo()?.userName" heading="Update User Info" maxWidth="498px" class="bmt-manage-user-info" (visibleChange)="resetUpdateUserForm()">
    @if (errorsfetchingUserInfo()) {
    <p class="error">Error fetching user info: {{errorsfetchingUserInfo()}}</p>
    }
    @if (!updatingUserStatus()) {
        @if (!errorsfetchingUserInfo() && !fetchingUserInfo()) {
        <div style="padding: 20px;display: flex;justify-content: space-around;overflow-x: scroll;flex-direction: column;">
            @if (errorsUpdatingUser()) {
            <p class="error">{{errorsUpdatingUser()}}</p>
            }
            <form [formGroup]="updateUserForm" class="bmt-create-user" (ngSubmit)="updateUserInfo()">
                <div style="width: 350px;">
                    <rs-input formControlName="userIdentifier" class="create-user-inputs" label="User Name:"></rs-input>
                    <rs-input validation="eager" formControlName="firstName" class="create-user-inputs" label="First Name:"></rs-input>
                    <rs-input validation="eager" formControlName="lastName" class="create-user-inputs" label="Last Name:"></rs-input>
                    <rs-input validation="eager" formControlName="companyName" class="create-user-inputs" label="Company Name:"></rs-input>
                    <rs-input validation="eager" type="email" formControlName="emailAddress" class="create-user-inputs" label="Email Address:"></rs-input>
                </div>
                <div style="padding-top: 20px;justify-content: space-between;display: flex;">
                    <button style="width: auto;" type="reset" rs-raised-button color="secondary" (click)="manageUserInfo.set(null)">Cancel</button>
                    <button style="width: auto;" [disabled]="!updateUserForm.valid || !areThereAnyChanges()" type="submit" rs-raised-button color="primary">Update</button>
                </div>
            </form>
        </div>
        }
    }
    @if (updatingUserStatus()) {
    <div class="status-update">
        <p>User info has been updated</p>
        <button style="width: auto;" (click)="resetUpdateUserForm()" rs-raised-button color="secondary">close</button>
    </div>
    }
</rs-dialog>
